import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';
import Check from 'components/common/Check';
import React from 'react';
import * as Signals from 'modules/Signals';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function SimulationDietGraph(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const [data, setData] = Recoil.useRecoilState(AppStore.assets.sim_meal);
  const [std_food_name, setStdFoodName] = Recoil.useRecoilState(AppStore.assets.std_food_name);
  const [cp_food_names, setCpFoodNames] = Recoil.useRecoilState(AppStore.assets.cp_food_names);
  const [show1, setOnly1] = Recoil.useRecoilState(AppStore.assets.show1);
  const onToggle = React.useCallback((e) => {
    setStdFoodName(() => '');
    setCpFoodNames(() => ['', '', '']);
    setOnly1(o => !o);
  }, [setCpFoodNames, setOnly1, setStdFoodName]);

  const {
    high_bldsugr_list = [],
    low_bldsugr_list = [],
  } = data || {};

  const [min, max] = React.useMemo(() => {
    let min = (high_bldsugr_list[0] || {}).bldsugr_rise_w || 50;
    let max = (high_bldsugr_list[0] || {}).bldsugr_rise_w || 250;
    high_bldsugr_list.forEach((item) => {
      const {
        bldsugr_rise_w,
      } = item;
      if (bldsugr_rise_w < min) min = bldsugr_rise_w;
      if (max < bldsugr_rise_w) max = bldsugr_rise_w;
    });
    low_bldsugr_list.forEach((item) => {
      const {
        bldsugr_rise_w,
      } = item;
      if (bldsugr_rise_w < min) min = bldsugr_rise_w;
      if (max < bldsugr_rise_w) max = bldsugr_rise_w;
    });
    return [Math.floor(min / 50) * 50, Math.ceil(max / 50) * 50];
  }, [high_bldsugr_list, low_bldsugr_list]);

  return (
    <VBox full {...ex('SimulationDietGraph', rest)}>
      <HBox full>
        <VBox between vend {...ex('Y')}>
          <VBox vend>
            <div>{T('혈당 상승폭')}</div>
            <div>{max}</div>
          </VBox>
          <div>{+((max * 2 + min) / 3).toFixed(0)}</div>
          <div>{+((max + min) / 2).toFixed(0)}</div>
          <div>{+((max + min * 2) / 3).toFixed(0)}</div>
          <div>{min}</div>
        </VBox>
        <HBox full {...ex('canvas')}>
          <div>
            <div {...ex('grid-x')} />
            <div {...ex('grid-x')} />
            <div {...ex('grid-x')} />
          </div>
          <div>
            <div {...ex('grid-y')} />
            <div {...ex('grid-y')} />
            <div {...ex('grid-y')} />
          </div>
          <div>
            {high_bldsugr_list.map((item, index) => {
              const {
                food_name,
                intake_cnt,
                bldsugr_rise_w,
              } = item;
              if (!show1 && intake_cnt < 2) return null;
              const std = std_food_name === food_name;
              const cp = cp_food_names.includes(food_name);
              return (
                <div key={index} {...ex(['Tag', { std, cp }])} {...{ style: { left: `${(Math.min(4, intake_cnt) - 1) * 25}%`, top: `${Math.min(95, Math.max(0, (1 - (bldsugr_rise_w - min) / (max - min)) * 100))}%` } }}>
                  {food_name}
                </div>
              );
            })}
            {/* {low_bldsugr_list.map((item, index) => {
              const {
                food_name,
                intake_cnt,
                bldsugr_rise_w,
              } = item;
              if (!show1 && intake_cnt < 2) return null;
              const std = std_food_name === food_name;
              const cp = cp_food_names.includes(food_name);
              return (
                <div key={index} {...ex(['Tag', { std, cp }])} {...{ style: { left: `${(Math.min(4, intake_cnt) - 1) * 25}%`, top: `${Math.min(95, Math.max(0, (1 - (bldsugr_rise_w - min) / (max - min)) * 100))}%` } }}>
                  {food_name}
                </div>
              );
            })} */}
          </div>
        </HBox>
      </HBox>
      <HBox>
        <div />
        <HBox full {...ex('X')}>
          <Check
            {...{
              checked: show1,
              onClick: onToggle,
            }}
          >
            {T('1회 나타내기')}
          </Check>
          <HBox full between>
            <div>
              1
            </div>
            <div>
              2
            </div>
            <div>
              3
            </div>
            <div>
              {T('기록')}
            </div>
          </HBox>
        </HBox>
      </HBox>
    </VBox>
  );
}
